import { ReactNode } from "react";

import { WasteStepperContext, WasteStepperContextValue } from "./WasteStepperContextValue";

type WasteStepperProviderValue = Omit<WasteStepperContextValue, "refetchSubmission"> & {
  refetchSubmission?: WasteStepperContextValue["refetchSubmission"];
};

const noOpRefetchSubmission = () => Promise.resolve();

export function WasteStepperProvider({
  value,
  children,
}: {
  value: WasteStepperProviderValue;
  children: ReactNode;
}) {
  return (
    <WasteStepperContext.Provider
      value={{
        ...value,
        refetchSubmission: value.refetchSubmission ?? noOpRefetchSubmission,
      }}
    >
      {children}
    </WasteStepperContext.Provider>
  );
}
